import { EventType} from '../../events';

const mapping: { [index:string]: string } = {
  [EventType.START_TRIAL]: 'ActivatedTrialSubscription',
  [EventType.PURCHASE]: 'PurchasedSubscription'
}

export default mapping;
